const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoYOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 228.11 79.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.26,27.68v14.29c0,1.29.24,2.26.72,2.9.49.66,1.25,1,2.24,1s1.75-.34,2.24-1c.48-.64.72-1.62.72-2.9v-14.29h1.79c1.36,0,2.35-.21,3.04-.63.71-.44,1.07-1.11,1.07-1.99s-.36-1.59-1.08-2.03c-.68-.42-1.7-.64-3.03-.64H7.49c-1.34,0-2.36.21-3.04.64-.71.44-1.07,1.13-1.07,2.03s.36,1.55,1.06,1.99c.68.42,1.67.63,3.05.63h1.77Z",
    style: {
      fill: "#f37920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.87,45.6h6.36c1.37,0,2.37-.21,3.05-.63.71-.44,1.06-1.12,1.06-2.01s-.36-1.55-1.06-1.99c-.68-.42-1.67-.63-3.05-.63h-4.37v-3.8h3.6c1.34,0,2.36-.21,3.04-.62.71-.43,1.07-1.11,1.07-2s-.36-1.57-1.07-2.01c-.67-.42-1.7-.63-3.04-.63h-3.6v-3.59h4.2c1.34,0,2.36-.21,3.04-.63.71-.44,1.07-1.11,1.07-1.99s-.36-1.59-1.08-2.03c-.68-.42-1.7-.64-3.03-.64h-6.13c-1.47,0-2.48.28-3.08.84-.61.57-.91,1.56-.91,3.03v15.83c0,1.34.28,2.24.87,2.75.57.5,1.58.74,3.06.74",
    style: {
      fill: "#f37920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.74,44.88c.48-.64.72-1.62.72-2.9v-4.95l5.95,7.08c.59.69,1.13,1.19,1.59,1.48.48.3.99.46,1.51.46.8,0,1.48-.26,2.02-.77.54-.51.81-1.15.81-1.9,0-.45-.14-.95-.43-1.48-.28-.51-.7-1.07-1.26-1.65l-4.01-4.23c1.63-.34,2.94-1.03,3.9-2.06,1.05-1.13,1.58-2.55,1.58-4.23,0-2.25-.85-4.06-2.52-5.37-1.66-1.3-3.95-1.96-6.83-1.96h-4.24c-1.47,0-2.47.28-3.08.84-.61.57-.91,1.56-.91,3.03v15.71c0,1.29.24,2.26.72,2.9.49.66,1.25,1,2.24,1s1.75-.34,2.24-1M54.46,32.68v-5.06h2.35c1.02,0,1.82.22,2.37.66.54.43.8,1.03.8,1.83s-.27,1.45-.82,1.89c-.56.45-1.37.68-2.42.68h-2.28Z",
    style: {
      fill: "#f37920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6,44.88c.48-.64.72-1.62.72-2.9v-4.95l5.94,7.08c.6.7,1.12,1.19,1.59,1.48.48.3.99.46,1.51.46.8,0,1.48-.26,2.01-.77.54-.51.81-1.15.81-1.9,0-.45-.15-.95-.43-1.48-.28-.51-.7-1.07-1.26-1.65l-4.01-4.23c1.63-.34,2.94-1.03,3.9-2.06,1.05-1.13,1.58-2.55,1.58-4.23,0-2.25-.85-4.06-2.52-5.37-1.65-1.3-3.95-1.96-6.83-1.96h-4.24c-1.47,0-2.47.28-3.08.84-.61.57-.91,1.56-.91,3.03v15.71c0,1.28.24,2.26.72,2.9.49.66,1.25,1,2.24,1s1.75-.34,2.24-1M79.32,32.68v-5.06h2.35c1.02,0,1.82.22,2.37.66.54.43.8,1.03.8,1.83s-.27,1.45-.82,1.89c-.56.45-1.37.68-2.41.68h-2.28Z",
    style: {
      fill: "#f37920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.05,23.03c-.68-.42-1.7-.64-3.03-.64h-9.48c-1.34,0-2.36.21-3.04.64-.71.44-1.07,1.13-1.07,2.03s.36,1.55,1.06,1.99c.68.42,1.67.63,3.05.63h1.77v14.29c0,1.29.24,2.26.72,2.9.49.66,1.25,1,2.24,1s1.75-.34,2.24-1c.48-.64.72-1.62.72-2.9v-14.29h1.79c1.36,0,2.35-.21,3.04-.63.71-.44,1.07-1.11,1.07-1.99s-.36-1.59-1.08-2.03",
    style: {
      fill: "#f37920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.69,34.01c0-3.63-1.12-6.61-3.32-8.86-2.2-2.25-5.13-3.4-8.69-3.4s-6.47,1.14-8.67,3.39c-2.2,2.25-3.31,5.23-3.31,8.87s1.11,6.64,3.29,8.88c2.19,2.24,5.11,3.38,8.68,3.38s6.5-1.14,8.7-3.38c2.2-2.24,3.31-5.23,3.31-8.88M149.62,28.99c1-1.23,2.37-1.85,4.06-1.85s3.06.62,4.06,1.85c1.01,1.24,1.52,2.95,1.52,5.08s-.52,3.72-1.54,4.95c-1.01,1.21-2.37,1.83-4.04,1.83s-3.03-.61-4.04-1.83c-1.02-1.23-1.54-2.89-1.54-4.95s.51-3.84,1.52-5.08",
    style: {
      fill: "#f37920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.75,45.28c.54-.51.81-1.15.81-1.9,0-.45-.14-.95-.43-1.48-.28-.51-.7-1.07-1.26-1.65l-4.01-4.23c1.63-.34,2.94-1.03,3.9-2.06,1.05-1.13,1.58-2.55,1.58-4.23,0-2.25-.85-4.06-2.52-5.37-1.66-1.3-3.95-1.96-6.83-1.96h-4.24c-1.46,0-2.47.28-3.08.85-.61.57-.91,1.56-.91,3.03v15.71c0,1.28.24,2.26.72,2.9.49.66,1.25,1,2.24,1s1.75-.34,2.24-1c.48-.64.72-1.62.72-2.9v-4.95l5.95,7.08c.6.7,1.12,1.19,1.59,1.48.48.3.99.46,1.51.46.8,0,1.48-.26,2.02-.77M180.2,30.11c0,.83-.27,1.45-.82,1.9-.56.45-1.37.68-2.42.68h-2.28v-5.06h2.35c1.03,0,1.82.22,2.37.66.54.43.8,1.03.8,1.83",
    style: {
      fill: "#f37920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.94,22.1c-.99,0-1.75.34-2.24,1.01-.48.65-.72,1.63-.72,2.91v15.96c0,1.28.24,2.26.72,2.9.49.66,1.25,1,2.24,1s1.75-.34,2.24-1c.48-.64.72-1.62.72-2.9v-15.96c0-1.28-.24-2.26-.72-2.91-.49-.67-1.25-1.01-2.24-1.01",
    style: {
      fill: "#f37920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.64,25.15c-2.2-2.25-5.13-3.4-8.69-3.4s-6.47,1.14-8.67,3.39c-2.2,2.25-3.31,5.23-3.31,8.87s1.11,6.64,3.3,8.88c2.19,2.24,5.11,3.38,8.68,3.38s6.5-1.14,8.7-3.38c2.2-2.24,3.31-5.23,3.31-8.88s-1.12-6.61-3.32-8.86M208.89,28.99c1-1.23,2.37-1.85,4.06-1.85s3.06.62,4.06,1.85c1.01,1.24,1.53,2.95,1.53,5.08s-.52,3.72-1.54,4.95c-1.01,1.21-2.37,1.83-4.04,1.83s-3.03-.61-4.04-1.83c-1.02-1.23-1.54-2.89-1.54-4.95s.51-3.84,1.52-5.08",
    style: {
      fill: "#f37920"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M94.71,5.72c-2.93,0-5.32,2.39-5.32,5.32s2.39,5.32,5.32,5.32,5.32-2.39,5.32-5.32-2.39-5.32-5.32-5.32",
    style: {
      fill: "#f37920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,10.77l1.86-2.58s0,0,0-.01c.93-1.44,2.55-2.39,4.39-2.39,2.88,0,5.22,2.34,5.22,5.23,0,1.07-.27,2.08-.88,2.89l-1.51,2h0s-9.09,12.32-9.09,12.32V10.77Z",
    style: {
      fill: "#f37920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.5,25.22l.08.06-.07.1v12.69h0v2.95c.11,2.91,2.51,5.25,5.45,5.25,2.75,0,5.02-2.05,5.39-4.7V10.28l-10.83,14.94Z",
    style: {
      fill: "#f37920"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.68,69.76v4.59h-1.25v-4.59l-4.04-6.41h1.45l3.26,5.15,3.26-5.15h1.48l-4.17,6.41Z",
    style: {
      fill: "#f37920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.63,72.02l-.85,2.33h-1.31l4.01-11h1.76l4.11,11h-1.29l-.87-2.33h-5.56ZM70.39,64.38l-2.42,6.62h4.87l-2.45-6.62Z",
    style: {
      fill: "#f37920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.17,74.44c-2.01,0-3.2-1.26-3.2-3.46v-4.26c0-3.11,1.92-3.46,4.59-3.46h1.03c2.3,0,3.01,1,3.01,3.17v.35h-1.25v-.31c0-1.54-.32-2.11-1.94-2.11h-.7c-2.58,0-3.49.31-3.49,2.32v3.02c0,2.51.1,3.64,2.19,3.64h1.48c2,0,2.61-.28,2.61-1.85v-.88h1.25v1.03c0,2.52-1.61,2.8-3.81,2.8h-1.76Z",
    style: {
      fill: "#f37920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.6,63.26c2.74.03,3.58.94,3.58,3.7v3.92c0,2.6-.94,3.57-3.58,3.57h-1.48c-2.64,0-3.58-.97-3.58-3.57v-3.92c0-2.76.84-3.67,3.58-3.7h1.48ZM101.12,64.36c-1.85,0-2.33.45-2.33,2.6v3.92c0,2.19.72,2.45,2.33,2.47h1.48c1.61-.02,2.33-.28,2.33-2.47v-3.92c0-2.14-.48-2.6-2.33-2.6h-1.48Z",
    style: {
      fill: "#f37920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.53,63.35h5.6c2.13,0,2.63,1.44,2.63,3.33,0,.98-.02,3.39-2.69,3.39h-4.3v4.28h-1.25v-11ZM114.77,64.45v4.52h3.23c1.66,0,2.51.01,2.51-2.13s-.38-2.39-1.92-2.39h-3.81Z",
    style: {
      fill: "#f37920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.54,74.36h-1.25v-11h1.25v11Z",
    style: {
      fill: "#f37920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.94,74.36h-2.04l-6.18-9.98h-.03v9.98h-1.25v-11h2.05l6.16,10.05h.03v-10.05h1.25v11Z",
    style: {
      fill: "#f37920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.11,74.36h-1.25v-11h1.25v11Z",
    style: {
      fill: "#f37920"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoYOrange);
export default __webpack_public_path__ + "static/media/logo-y-orange.6e05bd321d78ccb01e812b0b6ef74ea3.svg";
export { ForwardRef as ReactComponent };